module.exports = __webpack_public_path__ + "img/zoom-in.5c060e73.svg";